module.exports = __webpack_public_path__ + "img/qr.7c790688.jpg";